{
  "remove": "Press Space or Delete to remove tag."
}
